/**
 * El registro podado según lo que la persona logueada puede ver. Es la misma
 * vista para el menú lateral y el buscador ⌘K.
 *
 * Sin memorizar: `usePermissions` devuelve funciones nuevas en cada render y el
 * recorrido del árbol es barato.
 */
import { useAccesoAProyectos } from '@/features/projects/acceso/useAccesoAProyectos';
import { usePermissions } from '@/hooks/usePermissions';

import { REGISTRO, type Seccion } from './registro';
import { filtrarRegistro } from './visibilidad';

export function useRegistroVisible(): Seccion[] {
  const { isSuperadmin, has } = usePermissions();
  const { puede: participaDeProyectos } = useAccesoAProyectos();
  return filtrarRegistro(REGISTRO, { esSuperadmin: isSuperadmin, tiene: has, participaDeProyectos });
}
